module.exports = __webpack_public_path__ + "img/vip-12.c73ddcf7.png";